import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const benefitRows = [['✅ 6 Premium Volumes', '✅ 5 Bonus Kits'], ['✅ 120 Ready Classes', '✅ 52 Weekly Programs'], ['✅ 365 Daily Routines']];
export function Hero() {
  return <>
      <section className="w-full bg-navy px-4 py-5 text-white sm:py-7" data-id="element-106" data-mp="4lqkazhutj53">
        <div className="mx-auto max-w-4xl text-center" data-id="element-107" data-mp="4njng4t9dl8c">
          <motion.span initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45
        }} className="inline-flex whitespace-nowrap rounded-full border border-sage-light/40 bg-white/5 px-3 py-1 text-[9px] font-bold uppercase tracking-[0.08em] text-sage-light sm:text-[10px]" data-id="element-108" data-mp="129qvxpsonxpz">
            🧘🏻‍♀️ The #1 System for Stretching Instructors
          </motion.span>

          <motion.h1 initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.05
        }} className="mx-auto mt-2 max-w-xl font-serif text-3xl leading-[0.98] tracking-tight sm:text-4xl lg:text-5xl" data-id="element-109" data-mp="3czflm08u696k">
            The Complete Stretching<br data-id="element-110" data-mp="39acuwgqk58pb" />
            <span className="text-sage-light" data-id="element-111" data-mp="39authk0ozz0e">Teacher System™</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.12
        }} className="mx-auto mt-2 max-w-2xl text-sm leading-relaxed text-white/90 sm:text-base" data-id="element-112" data-mp="3e963pvuwgbj5">
            Ready-to-use lesson plans, stretching sequences, teaching guides, and printable resources for professional stretching instructors.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.2
        }} className="mx-auto mt-3 max-w-2xl text-center" data-id="element-113" data-mp="2vjpvsngvxgsp">
            <p className="text-xs font-bold uppercase tracking-[0.12em] text-sage-light" data-id="element-114" data-mp="2lml98mj4njbd">📦 Everything You Get Instantly</p>
            <div className="mt-1.5 space-y-1 text-xs font-medium text-white/90 sm:text-sm" data-id="element-115" data-mp="nat8heoiaqma">
              {benefitRows.map(row => <p key={row.join('-')} className="flex justify-center gap-x-4 whitespace-nowrap sm:gap-x-7" data-id="element-116" data-mp="icrpetr2yrat">
                  {row.map(benefit => <span key={benefit} data-id="element-117" data-mp="dbaoiy8lj4u8">{benefit}</span>)}
                </p>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.26
        }} className="mx-auto mt-2 max-w-4xl" data-id="element-118" data-mp="161aznetoxe5j">
            <img src="https://cdn.magicpatterns.com/uploads/k4cW4Mx1Tvt5mLkSh28TNQ/ChatGPT_Image_19_jul_2026,_03_15_27_p.m..png" alt="The Complete Stretching Teacher System digital volumes, bonus resources, desktop and mobile previews" className="mx-auto w-full max-w-3xl object-contain" data-id="element-119" data-mp="x0cqki4eagg3" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.32
        }} className="mt-2" data-id="element-120" data-mp="21aej5hv4snb5">
            <CTAButton size="large" data-id="element-121" data-mp="2b1932fkwnatf">GET INSTANT ACCESS</CTAButton>
            <p className="mx-auto mt-2 max-w-3xl text-xs leading-relaxed text-white/70 sm:text-sm" data-id="element-122" data-mp="2b2kbispap6qv">📄 High-Quality PDF <span className="mx-1" data-id="element-123" data-mp="2kyvolkwpm0md">·</span> 🖨️ Printable Resources <span className="mx-1" data-id="element-124" data-mp="2kxknjsunf6yy">·</span> ⚡ Instant Download <span className="mx-1" data-id="element-125" data-mp="2p0h5riga112d">·</span> 🔒 Secure Payment <span className="mx-1" data-id="element-126" data-mp="2p1s8dexzk2rw">·</span> 🛡️ 7-Day Guarantee</p>
          </motion.div>
        </div>
      </section>

      <section className="border-y border-amber bg-amber-pale px-4 py-5 text-navy" data-id="element-127" data-mp="2tysf7s2nt9k2">
        <div className="mx-auto max-w-3xl text-center" data-id="element-128" data-mp="uo0uu4cjcyr6">
          <p className="text-sm font-bold sm:text-base" data-id="element-129" data-mp="zl0yy9ptrrfn">🤸🏻 Launch offer active — Price increases when the timer hits zero</p>
          <div className="mx-auto mt-3 h-2 max-w-xl overflow-hidden rounded-full bg-amber/20" data-id="element-130" data-mp="4a2ulkgef9zm"><div className="h-full w-[72%] rounded-full bg-amber" data-id="element-131" data-mp="3vignm664gdyb" /></div>
          <p className="mt-2 text-xs font-medium text-slate" data-id="element-132" data-mp="e9jvzpomb1ps">72% of launch spots already claimed</p>
        </div>
      </section>
    </>;
}